import axios from 'axios';
import { API_URL } from '../config';
import { DocumentInstance, DocumentType } from '../types';
import { getAuthToken } from './authToken';

const MEMORIAL_NAME_PATTERN = /memorial\s*descritivo/i;

export const isMemorialDescritivoType = (
  documentType?: Pick<DocumentType, 'name'> | { name?: string | null } | null
): boolean => Boolean(documentType?.name && MEMORIAL_NAME_PATTERN.test(documentType.name));

export const isMemorialDescritivoInstance = (instance?: DocumentInstance | null): boolean =>
  isMemorialDescritivoType(instance?.document_type ?? null);

export interface MemorialDownloadStatus {
  is_memorial_descritivo: boolean;
  can_download: boolean;
  status: string;
  missing_fields: string[];
}

export const fetchMemorialDownloadStatus = async (
  instanceId: number
): Promise<MemorialDownloadStatus> => {
  const response = await axios.get(
    `${API_URL}/api/documents/instances/${instanceId}/download-status`
  );
  return response.data;
};

export const downloadMemorialDescritivo = async (
  instanceId: number,
  format: 'docx' | 'pdf'
): Promise<void> => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Usuário não autenticado');
  }

  const response = await axios.get(
    `${API_URL}/api/documents/instances/${instanceId}/download`,
    {
      params: { format },
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    }
  );

  const disposition = response.headers['content-disposition'] || '';
  let filename = `memorial_descritivo.${format}`;
  const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch) {
    try {
      filename = decodeURIComponent(utfMatch[1]);
    } catch {
      filename = utfMatch[1];
    }
  } else {
    const simpleMatch = disposition.match(/filename="([^"]+)"/i);
    if (simpleMatch) {
      filename = simpleMatch[1];
    }
  }

  const blob = new Blob([response.data], {
    type: response.headers['content-type'] || 'application/octet-stream',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
